let CartRemoveButton;

if (!customElements.get("cart-remove-button")) {
  CartRemoveButton = class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (event) => {
        event.preventDefault();
        const cartItems =
          this.closest("cart-items") || this.closest("cart-drawer-items");
        if (cartItems) {
          const line = this.dataset.index;
          cartItems.removeItem(line);
        }
      });
    }
  };

  customElements.define("cart-remove-button", CartRemoveButton);
}

// Replace the class with this simplified version
class CartItems extends HTMLElement {
	constructor() {
		super();

		const debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, 300);

		this.addEventListener("change", debouncedOnChange.bind(this));
	}

	removeItem(line) {
		if (!line) return;

		fetch("/cart/change.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-Requested-With": "XMLHttpRequest",
			},
			body: JSON.stringify({
				line: parseInt(line),
				quantity: 0,
			}),
		})
		.then((response) => response.json())
		.then((cart) => {
			console.log("✅ Item removed:", cart);

			// ✅ Instead of updateCartDisplay → just reload the page
			window.location.reload();
		})
		.catch((error) => {
			console.error("❌ Error removing item:", error);
		});
	}

	onChange(event) {
		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement ? document.activeElement.getAttribute("name") : ""
		);
	}

	enableLoading(line) {
		const mainCartItems = document.getElementById("main-cart-items");
		if (mainCartItems) mainCartItems.classList.add("cart__items--disabled");
	}

	disableLoading(line) {
		const mainCartItems = document.getElementById("main-cart-items");
		if (mainCartItems) mainCartItems.classList.remove("cart__items--disabled");
	}
}

// Register this element if you’re using <cart-items> in your HTML
customElements.define("cart-items", CartItems);

function debounce(func, wait) {
	let timeout;
	return function (...args) {
		const context = this;
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(context, args), wait);
	};
}

function trapFocus(element, focusElement) {
	if (!element || !focusElement) return;
	focusElement.focus();
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".cart-item").forEach((cartItem) => {
    const decreaseButton = cartItem.querySelector(".quantity-button.minus");
    const increaseButton = cartItem.querySelector(".quantity-button.plus");
    const quantityInput = cartItem.querySelector(".quantity-input");
    const itemKey = cartItem.dataset.key;
    const variantId = cartItem.dataset.variantId; // 🔑 You must set this in the HTML if not already

    if (!variantId || !decreaseButton || !increaseButton || !quantityInput) return;
    if (parseInt(quantityInput.value) >= parseInt(quantityInput.max)) {
  increaseButton.disabled = true;
  console.log("🔒 + button disabled on load due to max quantity.");
}

// ➕ ADD 1 TO CART – smarter logic
increaseButton.addEventListener("click", function () {
  const maxQty = parseInt(quantityInput.max);

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
    .then((res) => res.json())
    .then(() => {
      return fetch("/cart.js");
    })
    .then((res) => res.json())
    .then((cart) => {
      const lineItem = cart.items.find((item) => item.variant_id == variantId);

      if (lineItem) {
        const newQty = lineItem.quantity;
        console.log("🛒 New quantity in cart:", newQty);

        if (newQty >= maxQty) {
          increaseButton.disabled = true;
          console.log("⛔ Reached max. Disabled + button.");
        }
      }

      // ✅ Delay reload slightly to ensure button state updates
      setTimeout(() => {
        window.location.reload();
      }, 150); // Just enough time to show the disabled state
    })
    .catch((error) => console.error("❌ Error adding to cart:", error));
});

    // REMOVE FROM CART (−)
decreaseButton.addEventListener("click", function () {
  // Get current cart state first
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const item = cart.items.find((i) => i.key === itemKey);
      if (!item) return;

      const currentQty = item.quantity;
      const newQty = currentQty - 1;

      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newQty < 1 ? 0 : newQty,
        }),
      })
        .then((res) => res.json())
        .then((updatedCart) => {
          if (newQty < 1) {
            console.log("🗑️ Item fully removed from cart:", updatedCart);
          } else {
            console.log("➖ Decreased quantity by 1:", updatedCart);
          }
          window.location.reload();
        })
        .catch((error) =>
          console.error("❌ Error decreasing quantity:", error)
        );
    })
    .catch((error) =>
      console.error("❌ Error fetching current cart state:", error)
    );
});
  });
});

document.addEventListener("click", function (event) {
  const removeButton = event.target.closest(".button--simple");
  if (!removeButton) return;

  console.log("🗑️ Remove button clicked!");

  const cartItem = removeButton.closest(".cart-item");
  if (!cartItem) {
    console.log("⚠️ Cart item not found");
    return;
  }

  const itemKey = cartItem.dataset.key;
  if (!itemKey) {
    console.log("⚠️ Item key missing, cannot remove item");
    return;
  }

  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: itemKey,
      quantity: 0,
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      console.log("✅ Item removed:", data);
      window.location.reload();
    })
    .catch((error) => console.error("❌ Error removing item:", error));
});

document.addEventListener("DOMContentLoaded", function () {
  const clearCartButton = document.getElementById("clear-cart");

  if (clearCartButton) {
    clearCartButton.addEventListener("click", function () {
      // First get current cart
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          const updates = {};
          cart.items.forEach((item) => {
            updates[item.key] = 0; // Set quantity of all items to 0
          });

          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates }),
          });
        })
        .then((res) => res.json())
        .then((data) => {
          console.log("🧹 Cart cleared:", data);
          window.location.reload(); // Refresh to show empty cart
        })
        .catch((err) => console.error("❌ Error clearing cart:", err));
    });
  }
});
